// extracted by mini-css-extract-plugin
export default {"container":"PyvgrhaAf83h2d35CUh7"};